import { render, staticRenderFns } from "./CommonFormWithInvoiceEditor.vue?vue&type=template&id=bc1e3306&lang=pug&"
import script from "./CommonFormWithInvoiceEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithInvoiceEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithInvoiceEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports